export const FETCH_DISCLOSURE = 'app/Disclosures/FETCH_DISCLOSURE';
export const FETCH_DISCLOSURE_FAILURE = 'app/Disclosures/FETCH_DISCLOSURE_FAILURE';
export const FETCH_DISCLOSURE_SUCCESS = 'app/Disclosures/FETCH_DISCLOSURE_SUCCESS';

export const RESET_ERROR_STATE = 'app/Disclosures/RESET_ERROR_STATE';
export const RESET_REQUEST_STATUS_STATE = 'app/Disclosures/RESET_REQUEST_STATUS_STATE';
export const RESET_STATE = 'app/Disclosures/RESET_STATE';

export const INVALID_DISCLOSURE_MESSAGE =
  'An error has occurred while retrieving the page content. Please try again later.';

/**
 * Given that we are using the same CMS Disclosure record for both SS2 and SS3,
 * the dictionary below maps SS2 web links (keys) to their respective SS3 desktop / mobile
 * links (values)
 */
export const INTERNAL_LINK_DICTIONARY = {
  desktop: {
    '/learningcenter': '/help/learningcenter',
    '/learningvideos?video=payment_assistance_options': '/help/learningcenter',
    '/learningvideos?video=understanding_insurance_claims': '/help/learningcenter',
    '/lossdraft': '/help/learningcenter',
  },
  mobile: {
    '/learningcenter': 'LearningCenter',
    '/learningvideos?video=payment_assistance_options': 'LearningCenter',
    '/learningvideos?video=understanding_insurance_claims': 'LearningCenter',
    '/lossdraft': 'LearningCenter',
  },
};
